import {
  Inject,
  ModuleWithProviders,
  NgModule,
  PLATFORM_ID,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PixelConfiguration } from './services/facebook-pixel/pixel.models';
import { isPlatformBrowser } from '@angular/common';
import { PixelService } from './services/facebook-pixel/pixel.service';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class FacebookPixelModule { 
  private static config: PixelConfiguration | null = null;

  constructor(
    private pixel: PixelService,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    if (!FacebookPixelModule.config) {
      throw Error(
        ' not configured correctly. Pass the `pixelId` property to the `forRoot()` function'
      );
    }
    if (FacebookPixelModule.config.enabled && isPlatformBrowser(platformId)) {
      this.pixel.initialize();
    }
  }

  /**
   * @description
   * Initiale the Facebook Pixel Module
   * Add your Pixel ID as parameter
   */
  static forRoot(config: PixelConfiguration): ModuleWithProviders<FacebookPixelModule> {
    this.config = config;
    const pixelId = config.pixelId;
    this.verifyPixelId(pixelId);

    return {
      ngModule: FacebookPixelModule,
      providers: [PixelService, { provide: 'config', useValue: config }],
    };
  }

  /**
   * @description
   * Verifies the Pixel ID that was passed into the configuration.
   * - Checks if Pixel was initialized
   * @param pixelId Pixel ID to verify
   */
  private static verifyPixelId(pixelId: string[]): void {
    // Have to verify first that all Pixel IDs follow the same 15 digit format
    pixelId.forEach((id) => {
      if (id === null || id === undefined || id.length === 0) {
        throw Error(
          'Invalid Facebook Pixel ID. Did you pass the ID into the forRoot() function?'
        );
      }
    });
  }
}
